import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AadhaarOtpPage } from './aadhaar-otp.page';

const routes: Routes = [
  {
    path: '',
    component: AadhaarOtpPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AadhaarOtpPageRoutingModule {}
